import {Component} from '@angular/core';
import {FooterComponent, HeaderComponent} from '../templates';
import {InnerComponent} from './inner/inner.component';
import {NAV_MENUS} from '../common/constants';

export const DASHBOARD_TAB = {
    IN_DESIGN: 'IN_DESIGN',
    READY_FOR_QA: 'READY_FOR_QA',
    READY_FOR_CERTIFICATION: 'READY_FOR_CERTIFICATION',
    CERTIFIED: 'CERTIFIED',
    LODGED: 'LODGED'
};

@Component({
    selector: 'nlr-plan-dashboard',
    imports: [HeaderComponent, FooterComponent, InnerComponent],
    templateUrl: './plan-dashboard.component.html',
    styleUrl: './plan-dashboard.component.scss'
})
export class PlanDashboardComponent {
    title: string = NAV_MENUS.DASHBOARD;
}
